import * as React from 'react'
import { connect } from 'react-redux'

import { IRootState } from '../../../../../common/reducers'

import EmptyItemCard from './emptyItemCard'

interface IStateProps {
  viewType: string
}

const mapStateToProps = (state: IRootState): IStateProps => {
  const { user: { preferences: { searchResultsViewType } } } = state
  return { viewType: searchResultsViewType }
}

const EmptyItemCardContainer = connect<IStateProps, {}, any, IRootState>(
  mapStateToProps
)(EmptyItemCard)

export default EmptyItemCardContainer
